module.exports = __webpack_public_path__ + "static/img/music_liebiao.d7a7cc0b.png";